


<router-outlet></router-outlet>
<app-forminput></app-forminput>